import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MemoryRouter } from "react-router-dom";

import { AppProviders } from "./app/AppProviders";
import { AppRoutes } from "./app/AppRoutes";
import { expand, ready } from "./lib/telegram";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Не найден корневой элемент #root");
}

ready();
expand();

// Роутинг живёт в памяти (docs/07-miniapp-ux.md §3): адресную строку читаем один раз,
// чтобы узнать /s/<slug>, из которого открыли витрину, а дальше навигация её не трогает —
// это нужно для нативного BackButton, который синхронизируется с историей роутера, а не с браузером.
const initialRoute = window.location.pathname + window.location.search;

createRoot(container).render(
  <StrictMode>
    <MemoryRouter initialEntries={[initialRoute]}>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </MemoryRouter>
  </StrictMode>,
);
